/**
 * V209.10: Auth Shell - Minimal providers for /auth route
 * 
 * This shell only includes essential providers needed for authentication.
 * Heavy providers (NetworkDataProvider, MessagesDataProvider) are excluded
 * to keep /auth bundle size minimal.
 */

import React from 'react';

interface AuthShellProps {
  children: React.ReactNode;
}

export const AuthShell: React.FC<AuthShellProps> = ({ children }) => {
  // V209.10: Minimal shell - no heavy providers
  // NetworkDataProvider and MessagesDataProvider are NOT imported here
  return <>{children}</>;
};
